type BuildPublicNoticesSearchParams = {
  districtCodes?: string[];
  stateCodes?: string[];
  pageNumber?: number;
  searchText?: string;
};

type PublicNoticesSearch = {
  district?: string;
  state?: string;
  page?: number;
  search?: string;
};

export const parseSearchList = (value?: string | null): string[] => {
  return value
    ? value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    : [];
};

export const buildPublicNoticesSearch = ({
  districtCodes = [],
  stateCodes = [],
  pageNumber = 1,
  searchText = '',
}: BuildPublicNoticesSearchParams): PublicNoticesSearch => ({
  district: districtCodes.length ? districtCodes.join(',') : undefined,
  state: stateCodes.length ? stateCodes.join(',') : undefined,
  page: pageNumber > 1 ? pageNumber : undefined,
  search: searchText || undefined,
});
